import moment from 'moment';


class DateTimeView {

    updateView() {
        this.view = this.value
            ? moment(this.value).format(this.format)
            : this.placeholder;
    }

    $onInit() {

        switch (this.mode) {
            case 'date':
                this.format = ttb.constants.dateTime.DATE_FORMAT;
                break;
            case 'time':
                this.format = ttb.constants.dateTime.TIME_FORMAT;
                break;
            default:
                this.format = ttb.constants.dateTime.DATE_TIME_FORMAT;
        }

        this.updateView();

    }
    $onChanges(changes) {
        if (changes.value) {
            this.updateView();
        }
    }
}

DateTimeView.$inject = [];

export default DateTimeView;


// WEBPACK FOOTER //
// ../widgets/date-time-view/date-time-view.controller.js